import { MarketCountryCode } from '@backmarket/http-api'

export const countriesWithLanding = [
  MarketCountryCode.US,
  MarketCountryCode.GB,
  MarketCountryCode.FR,
  MarketCountryCode.DE,
  MarketCountryCode.ES,
]
